import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { EpaApi } from '../../../services'


interface RequestOptions {
  pwsId: string,
  options?: AxiosRequestConfig
}

export const fetchViolationsEnforcementsGroupedByViolationAsync = createAsyncThunk<{}, RequestOptions>(
  'violationsEnforcements/fetchGroupedByViolation',
  async ({ options, pwsId }, { rejectWithValue }) => {
    try {
      const request = (await EpaApi.fetchViolationsEnforcementsGroupedByViolation(
        pwsId,
        options,
      )) as AxiosResponse<any>
      console.log(request.data, pwsId)
      return request.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const fetchViolationsEnforcementsGroupedByViolationAsyncBuilder = (
  builder: ActionReducerMapBuilder<any>
) => {
  builder.addCase(fetchViolationsEnforcementsGroupedByViolationAsync.pending, (state) => {
    state.groupedEnforcementsByViolation.loading = true;
    state.groupedEnforcementsByViolation.success = false;
    state.groupedEnforcementsByViolation.error = '';
  })
  builder.addCase(
    fetchViolationsEnforcementsGroupedByViolationAsync.fulfilled,
    (state, action: PayloadAction<any>) => {
      state.groupedEnforcementsByViolation.loading = false;
      state.groupedEnforcementsByViolation.success = true;
      state.groupedEnforcementsByViolation.data = action.payload;
    }
  )
  builder.addCase(
    fetchViolationsEnforcementsGroupedByViolationAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.groupedEnforcementsByViolation.loading = false;
      state.groupedEnforcementsByViolation.success = false;
      state.groupedEnforcementsByViolation.error = action.payload;
    }
  )
}